// @format

export function initOverview(): void {
  $(document).on('change', '#overview-companies-dropdown select', e => {
    window.location.href =
      '/overview?for_company=' +
      $('#overview-companies-dropdown option:selected').val();
  });

  $(document).on('change',  '#home-view-companies-dropdown select', e => {
    window.location.href =
      '/home?for_company=' +
      $('#home-view-companies-dropdown option:selected').val();
  });
}
